import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { history } from '../store'
import { withNamespaces } from 'react-i18next'
import { XCircle } from 'lucide-react'

import AppRentalHeader from '../containers/AppRentalHeader'

class PaymentRentalError extends React.Component {
  constructor(props) {
    super(props)
    this.state = { qr: '' }
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search)
    const qr = searchParams.get('qr')
    const language = searchParams.get('language')

    if (language) this.props.i18n.changeLanguage(language)
    if (qr) this.setState({ qr })
  }

  render() {
    const { t } = this.props
    const { qr } = this.state

    return (
      <div className="rentalBackground">
        <AppRentalHeader />
        <div className="nm-page-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '70vh', gap: '24px', padding: '32px 16px' }}>
          <XCircle size={64} strokeWidth={1.2} style={{ color: '#dc2626' }} />
          <h2 style={{ textAlign: 'center', color: '#fff', margin: 0 }}>
            {t('No se ha podido realizar la compra. Vuelve a intentarlo más tarde.')}
          </h2>
          <button
            className="nm-btn-primary"
            onClick={() => history.push(`/qrsale/${qr}`)}
          >
            {t('Volver al inicio')}
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => ({ auth: true })
const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch)
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(PaymentRentalError))
